import axios from "axios"
const API_URL = "https://vestshop-api.vercel.app/api"


// GET PRODUCTS
export const handleGetData = async (min , max, cat , search , color) => {
    try{
        const res = await axios.get(`${API_URL}/getProducts` , {params : {min , max , cat , search , color}})
        return res.data
    }catch(err){
        console.log(err)
    }
}
export const handleGetDatas = async () => {
    try{
        const res = await axios.get(`${API_URL}/getProductss`)
        return res.data
    }catch(err){
        console.log(err)
    }
}
// GET EACH PRODUCTS
export const handleGetEachData = async (params) => {
    try{
        const res = await axios.get(`${API_URL}/getProduct/${params}`)
        console.log(res.data)
        return res.data
    }catch(err){
        console.log(err)
    }
}
